import { pushToDataLayer } from '@/utils/dataLayer'

interface INavigationDataLayer {
  event_action?: string
  event_label?: string
  event_category: string
  page_type: string
}

export const useNavigationDataLayer = () => {
  const { locale } = useI18n()

  const pushNavigationDataLayer = (data: INavigationDataLayer) => {
    const eventData = {
      event: 'navigation_event',
      site_language: locale.value,
      ...data
    }
    pushToDataLayer(eventData)
  }

  return { pushNavigationDataLayer }
}
